import { useCallback } from "react";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import type { MRT_TableOptions } from "material-react-table";
import { CampaignListTable } from "Components/Admin/Campaigns/CampaignListTable/CampaignListTable";
import { useDeleteCampaignMutation } from "Api/Mutations/Admin/useDeleteCampaignMutation";
import { toast } from "sonner";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";

const RESOURCES = Resources.Admin.Campaigns;

type Props = {
  data: Array<AdminCampaignDto>;
  isLoading: boolean;
  isRefetching: boolean;
  rowCount?: number;
  tableProps?: Partial<MRT_TableOptions<AdminCampaignDto>>;
};

export const CampaignListTableWrapper = ({
  data,
  isLoading,
  isRefetching,
  rowCount,
  tableProps,
}: Props) => {
  const { t } = useResource();

  const { mutate: deleteCampaign } = useDeleteCampaignMutation({
    onSuccess: () => {
      toast.success(t(RESOURCES.Messages.DeleteSuccess));
    },
    onError: () => {
      toast.error(t(RESOURCES.Messages.DeleteError));
    },
  });

  const handleDelete = useCallback(
    (id: number) => {
      if (window.confirm(t(RESOURCES.Messages.DeleteConfirm))) {
        deleteCampaign(id);
      }
    },
    [t, deleteCampaign],
  );

  return (
    <CampaignListTable
      data={data}
      isLoading={isLoading}
      isRefetching={isRefetching}
      onDelete={handleDelete}
      rowCount={rowCount}
      tableProps={tableProps}
    />
  );
};
